import { ROLES } from 'constants/index';

import homeRoutes from 'routes/routesConfig/homeRoutes';
import commonRoutes from 'routes/routesConfig/commonRoutes';



export const getAuthRoutes = role => {
  let authRoutes = [];

  switch (role) {
    case ROLES.USER:
      authRoutes = authRoutes.concat([...homeRoutes]);
      break;
    default:
      break;
  }

  return authRoutes.concat(commonRoutes);
};
